import { KeycloakAuthProvider } from '../methods/keycloak/KeycloakAuthProvider';
import { SimulatedAuthProvider } from '../methods/simulated/SimulatedAuthProvider';

const isKeycloakEnabled = () =>
  Boolean(process.env.REACT_APP_OIDC_AUTHORITY?.trim());

export const AuthProvider = ({ children }) => {
  if (isKeycloakEnabled()) {
    return <KeycloakAuthProvider>{children}</KeycloakAuthProvider>;
  }

  return <SimulatedAuthProvider>{children}</SimulatedAuthProvider>;
};
